var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useEffect, useMemo } from "react";
import { usePortfolioStore } from "store";
import useCoinsData from "./useCoinsPrice";
var useProfileCoinsData = function () {
    var query = useCoinsData();
    var profileBalances = usePortfolioStore(function (state) { return state.profileBalances; });
    var initializeProfileBalances = usePortfolioStore(function (state) { return state.initializeProfileBalances; });
    useEffect(function () {
        var _a;
        if ((_a = query.data) === null || _a === void 0 ? void 0 : _a.length) {
            initializeProfileBalances(query.data);
        }
    }, [initializeProfileBalances, query.data]);
    var data = useMemo(function () {
        var _a;
        return ((_a = query.data) !== null && _a !== void 0 ? _a : []).map(function (coin) {
            var _a, _b;
            return (__assign(__assign({}, coin), { owned: (_b = (_a = profileBalances[coin.title]) !== null && _a !== void 0 ? _a : coin.owned) !== null && _b !== void 0 ? _b : 0 }));
        });
    }, [profileBalances, query.data]);
    return __assign(__assign({}, query), { data: data });
};
export default useProfileCoinsData;
